import {
  getEmailList,
  getCaseDetail,
  GetCaseDetail,
  getAgentList,
  createTask,
  getAttackTypeList,
  saveCaseToTemplate,
  GetTemplateList,
  getTemplateList,
  GetCaseList,
  getCaseList,
  getAllTemplateId,
  getAllCaseId,
  getResourceTagList,
  getResourceIdsByTemplateIds,
  getSecurityDeviceList,
  getTaskDetail,
} from '@/api/web-create-task'
import { getTaskGroups } from '@/api/account-center/task-management'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取任务分组
export const useTaskGroup = () => {
  const { runAsync: run, data } = useRequest(params => getTaskGroups(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取分组列表失败'))
    },
  })

  return [data?.data?.groups || [], run] as const
}

export const useGetEmailList = () => {
  const { data } = useRequest(getEmailList, {
    onError(err: any) {
      Message.error(err?.msg || t('目标发件邮箱获取失败'))
    },
  })
  return [data?.data?.emailUsers || []] as const
}

// 获取用例详情
export const useGetCaseDetail = () => {
  const { data, runAsync, loading } = useRequest((params: GetCaseDetail) => getCaseDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例详情失败'))
    },
  })
  return [data?.data || {}, runAsync, loading] as const
}

// 获取agent列表
export const useGetAgentList = () => {
  const { data, runAsync } = useRequest(getAgentList, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取agent列表失败'))
    },
  })
  return [data?.data?.items || [], runAsync] as const
}

// 安全设备
export const useGetSecurityDeviceList = () => {
  const { data, runAsync } = useRequest(getSecurityDeviceList, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备列表失败'))
    },
  })
  return [data?.data?.deviceList || [], runAsync] as const
}

// 创建任务
export const useCreateTask = () => {
  const { runAsync, loading } = useRequest(createTask, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('创建任务失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取攻击类型列表
export const useAttackTypeList = () => {
  const { data, runAsync } = useRequest(params => getAttackTypeList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取攻击类型列表失败'))
    },
  })
  return [data?.data?.attackTypeFilters || [], runAsync] as const
}

// 保存用例到模板
export const useSaveCaseToTemplate = () => {
  const { runAsync, loading } = useRequest(saveCaseToTemplate, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('保存用例到模板失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取模板列表
export const useGetTemplateList = () => {
  const { runAsync, loading } = useRequest((params: GetTemplateList) => getTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板列表失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取关联用例列表
export const useGetCaseList = () => {
  const { runAsync, loading } = useRequest((params: GetCaseList) => getCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联用例列表失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取所有模板id
export const useGetAllTemplateId = () => {
  const { data, runAsync } = useRequest((params: GetTemplateList) => getAllTemplateId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有模板id失败'))
    },
  })
  return [runAsync] as const
}

// 获取所有用例id
export const useGetAllCaseId = () => {
  const { data, runAsync } = useRequest((params: GetCaseList) => getAllCaseId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有用例id失败'))
    },
  })
  return [runAsync] as const
}

// 获取用例标签
export const useResourceTagList = () => {
  const { data, runAsync } = useRequest(params => getResourceTagList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例标签失败'))
    },
  })
  return [data?.data?.categoryList || [], runAsync] as const
}

// 根据templateIds获取resourceIds
export const useGetResourceIdsByTemplateIds = () => {
  const { data, runAsync } = useRequest(params => getResourceIdsByTemplateIds(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取资源id失败'))
    },
  })
  return [data?.data?.resourceIds || [], runAsync] as const
}

// 任务复制
export const useGetTaskDetail = () => {
  const { runAsync, data } = useRequest(params => getTaskDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })
  return [runAsync, data?.data || []] as const
}
